// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ErE5u","requiredAsterisk":"Info_requiredAsterisk__1Ni9G"};